import { Navigate, useRoutes } from 'react-router-dom';
import EnterReceipts from 'src/pages/EnterReceipts';
import AuthGuard from './components/guards/AuthGaurd';
import ActionRequiredInvoices from './pages/ActionRequiredInvoices';
import Elmah from './pages/Elmah';
import EnterInvoices from './pages/EnterInvoices';
import InvoiceDetails from './pages/InvoiceDetails';
import InvoiceScanManager from './pages/InvoiceScanManager';
import NotFound from './pages/NotFound';
import ReceiptDetails from './pages/ReceiptDetails';
import ScanManager from './pages/ScanManager';
import VarianceDetails from './pages/VarianceDetails';
import Variances from './pages/Variances';
import ViewAccrualReport from './pages/ViewAccrualReport';
import ViewBudgetPeriod from './pages/ViewBudgetPeriod';
import ViewCheckbook from './pages/ViewCheckbook';
import ViewCheckbookConfiguration from './pages/ViewCheckbookConfiguration';
import ViewDepartments from './pages/ViewDepartments';
import ViewInvoices from './pages/ViewInvoices';
import ViewPeriods from './pages/ViewPeriods';
import ViewReceipts from './pages/ViewReceipts';

const Router = () =>
  useRoutes([
    {
      path: '',
      element: <AuthGuard />,
      children: [
        { path: '', element: <Navigate to="po" /> },
        { path: 'view-receipts', element: <ViewReceipts /> },
        { path: 'po/receiptdetails', element: <ReceiptDetails /> },
        { path: 'po', element: <EnterReceipts /> },
        { path: 'create-receipt', element: <EnterReceipts /> },
        { path: 'view-invoices', element: <ViewInvoices /> },
        { path: 'enter-invoice', element: <EnterInvoices /> },
        { path: 'invoicedetails', element: <InvoiceDetails /> },
        { path: 'scan-manager-invoices', element: <InvoiceScanManager /> },
        { path: 'scan-manager-receipts', element: <ScanManager isInvoices={false} /> },
        { path: 'action-required-invoices', element: <ActionRequiredInvoices /> },
        { path: 'variances', element: <Variances /> },
        { path: 'variance-details', element: <VarianceDetails /> },
        { path: 'view-checkbook', element: <ViewCheckbook /> },
        { path: 'MPADetails', element: <ViewBudgetPeriod /> },
        { path: 'view-edit-departments', element: <ViewDepartments /> },
        { path: 'view-edit-glperiods', element: <ViewPeriods /> },
        { path: 'view-checkbook-configuration', element: <ViewCheckbookConfiguration /> },
        { path: 'accrual-report', element: <ViewAccrualReport /> },
      ],
    },
    {
      path: '',
      children: [{ path: 'elmah', element: <Elmah /> }],
    },
    { path: '*', element: <NotFound /> },
  ]);

export default Router;
